import type React from "react"
import { AlertCuration } from "./AlertCuration"
import { AlertCurationProvider } from "./AlertCurationContext"
import { useShowPrecomputedBiothreatSignals } from "../../hooks/useFeatureFlags"
import { BiothreatV2Page } from "../PrecomputedBiothreatSignals/v2/BiothreatV2Page"
import { PrecomputedBiothreatSignalsProvider } from "../PrecomputedBiothreatSignals/PrecomputedBiothreatSignalsContext"
import { ErrorBoundary } from "../Shared/ErrorBoundary"

export const AlertCurationGated: React.FC = () => {
  const showPrecomputed = useShowPrecomputedBiothreatSignals()

  if (showPrecomputed) {
    return (
      <PrecomputedBiothreatSignalsProvider>
        <BiothreatV2Page />
      </PrecomputedBiothreatSignalsProvider>
    )
  }

  return (
    <ErrorBoundary>
      <AlertCurationProvider>
        <AlertCuration />
      </AlertCurationProvider>
    </ErrorBoundary>
  )
}
